import { render, staticRenderFns } from "./CampaignMemberProfile.vue?vue&type=template&id=21180e14"
import script from "./CampaignMemberProfile.vue?vue&type=script&lang=js"
export * from "./CampaignMemberProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports